/**
 * Meridian next-drop globe — Shopify-style WebGL sphere (cobe).
 * Pin: Incahuasi / Cusco, Peru ≈ 13.35°S, 73.25°W
 */
(function () {
  var createGlobe =
    typeof CobeGlobe !== 'undefined' ? CobeGlobe.default || CobeGlobe : null;
  if (!createGlobe || typeof createGlobe !== 'function') return;

  var INCAHUASI = { location: [-13.35, -73.25], size: 0.1 };
  var CUSCO = { location: [-13.53, -71.97], size: 0.04 };

  // cobe camera so lat/lng sits at the center of the globe
  function locationToAngles(lat, lng) {
    return [
      Math.PI - ((lng * Math.PI) / 180 - Math.PI / 2),
      (lat * Math.PI) / 180
    ];
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initGlobe(root) {
    if (!root || root.getAttribute('data-globe-ready') === '1') return;
    var canvas = root.querySelector('[data-meridian-globe-canvas]');
    var frame = root.querySelector('[data-meridian-globe-frame]');
    if (!canvas) return;

    root.setAttribute('data-globe-ready', '1');

    var size = Math.min(Math.max(root.clientWidth || 320, 220), 520);
    // Start: Incahuasi dead-center (Peru / South America) — same frame as your screenshot
    var focus = locationToAngles(INCAHUASI.location[0], INCAHUASI.location[1]);
    var phi = focus[0]; // ~5.991
    var theta = focus[1]; // ~-0.233
    var dragging = false;
    var lastX = 0;
    var lastY = 0;
    var autoSpin = false;
    var destroyed = false;
    var globe = null;

    function syncSize() {
      size = Math.min(Math.max(root.clientWidth || 320, 220), 520);
      canvas.width = size * 2;
      canvas.height = size * 2;
      canvas.style.width = size + 'px';
      canvas.style.height = size + 'px';
      return size;
    }

    syncSize();

    try {
      globe = createGlobe(canvas, {
        devicePixelRatio: Math.min(window.devicePixelRatio || 1, 2),
        width: size * 2,
        height: size * 2,
        phi: phi,
        theta: theta,
        dark: 1,
        diffuse: 1.35,
        mapSamples: 14000,
        mapBrightness: 5.8,
        mapBaseBrightness: 0.08,
        baseColor: [0.12, 0.22, 0.34],
        markerColor: [0.1, 0.78, 0.82],
        glowColor: [0.08, 0.42, 0.48],
        markers: [INCAHUASI, CUSCO],
        opacity: 1,
        scale: 1.08,
        offset: [0, 0],
        onRender: function (state) {
          if (destroyed) return state;
          state.phi = phi;
          state.theta = theta;
          state.width = size * 2;
          state.height = size * 2;
          if (autoSpin && !dragging) {
            phi += 0.0022;
          }
          return state;
        }
      });
    } catch (err) {
      root.classList.add('is-fallback');
      return;
    }

    requestAnimationFrame(function () {
      if (frame) frame.classList.add('is-visible');
      root.classList.add('is-visible');
    });

    function onPointerDown(e) {
      dragging = true;
      autoSpin = false;
      lastX = e.clientX;
      lastY = e.clientY;
      try {
        canvas.setPointerCapture(e.pointerId);
      } catch (e2) {}
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var dx = e.clientX - lastX;
      var dy = e.clientY - lastY;
      lastX = e.clientX;
      lastY = e.clientY;
      phi += dx * 0.005;
      theta = Math.max(-0.6, Math.min(0.7, theta + dy * 0.0035));
    }

    function onPointerUp(e) {
      dragging = false;
      try {
        canvas.releasePointerCapture(e.pointerId);
      } catch (e2) {}
      // Stay where the visitor leaves it — no auto-spin resume
    }

    canvas.addEventListener('pointerdown', onPointerDown);
    canvas.addEventListener('pointermove', onPointerMove);
    canvas.addEventListener('pointerup', onPointerUp);
    canvas.addEventListener('pointercancel', onPointerUp);
    canvas.style.touchAction = 'none';
    canvas.style.cursor = 'grab';
    canvas.addEventListener('pointerdown', function () {
      canvas.style.cursor = 'grabbing';
    });
    canvas.addEventListener('pointerup', function () {
      canvas.style.cursor = 'grab';
    });

    var resizeTimer = null;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (destroyed || !globe) return;
        syncSize();
      }, 120);
    }
    window.addEventListener('resize', onResize);

    root._meridianGlobeDestroy = function () {
      destroyed = true;
      window.removeEventListener('resize', onResize);
      canvas.removeEventListener('pointerdown', onPointerDown);
      canvas.removeEventListener('pointermove', onPointerMove);
      canvas.removeEventListener('pointerup', onPointerUp);
      canvas.removeEventListener('pointercancel', onPointerUp);
      if (globe && typeof globe.destroy === 'function') globe.destroy();
      root.removeAttribute('data-globe-ready');
      if (frame) frame.classList.remove('is-visible');
      root.classList.remove('is-visible');
    };
  }

  function findRoots(scope) {
    return (scope || document).querySelectorAll('[data-meridian-globe]');
  }

  function boot() {
    findRoots(document).forEach(function (root) {
      var panel = root.closest('details');
      var tryInit = function () {
        if (panel && !panel.open) return;
        initGlobe(root);
      };

      if (panel) {
        panel.addEventListener('toggle', function () {
          if (panel.open) {
            tryInit();
          } else if (root._meridianGlobeDestroy) {
            root._meridianGlobeDestroy();
          }
        });
        if (panel.open) tryInit();
      } else {
        tryInit();
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) tryInit();
            });
          },
          { rootMargin: '80px', threshold: 0.15 }
        );
        io.observe(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
